import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normalise une référence OEM ou fabricant pour la recherche
 * Supprime les espaces, tirets, points, underscores et convertit en majuscules
 * 
 * Exemples:
 * - "58311-C8A30" -> "58311C8A30"
 * - "58311 C8A30" -> "58311C8A30"
 * - "58311.C8A30" -> "58311C8A30"
 * - "58311_c8a30" -> "58311C8A30"
 */
export function normalizeReference(ref: string): string {
  return ref
    .trim()
    .replace(/[\s\-._]+/g, '')
    .toUpperCase();
}
